module.exports = __webpack_public_path__ + "g.no1.3da13ff7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/g.no1.jpg
// module id = J2xd
// module chunks = 0